.pes-software-modal {
  padding: 15px 20px 10px;
  color: #333333;
}

@media screen and (min-width: 980px) {
  .pes-software-modal {
    padding: 6px 12px 48px;
  }
}

@media screen and (max-width: 719px) {
  .pes-software-modal {
    padding: 0 2px 24px;
  }
}

.pes-software-modal__row {
  display: block;
  border-bottom: 1px solid #e7e6e6;
  margin-bottom: 15px;
}

@media screen and (min-width: 980px) {
  .pes-software-modal__row {
    margin: 0;
  }
}

.pes-software-modal__row:last-child {
  border-bottom: 0;
}